import { FC } from 'react';
import { HStack, VStack } from '@chakra-ui/react';
import { InvoiceType, StatusBadge } from '@shinetools/invoicing-renderer';

import { formatAmount } from 'common/formatAmount';
import { InvoiceFromList } from 'common/hooks/useGetInvoicesQuery';
import SunshineCard from 'components/_core/SunshineCard';
import { formatDate } from 'helpers/date';

import locales from './locales';

interface ItemProps {
  invoice: InvoiceFromList;
}

const Item: FC<ItemProps> = ({ invoice }) => {
  return (
    <SunshineCard
      key={invoice.invoiceId}
      value={invoice.invoiceId}
      variant="radio"
    >
      <SunshineCard.Content>
        <HStack
          alignItems="flex-start"
          justifyContent="space-between"
          width="full"
        >
          <VStack alignItems="flex-start">
            <SunshineCard.Title>
              {invoice.title} · {invoice.client.name}
            </SunshineCard.Title>

            <SunshineCard.Text>
              {locales.formatString(locales.subtitle, {
                createdAt: formatDate(new Date(invoice.createdAt), 'P'),
                fiscalId: invoice.fiscalId,
              })}
            </SunshineCard.Text>
          </VStack>

          <VStack alignItems="flex-end">
            <SunshineCard.Text size="md">
              {formatAmount({
                forcePlusSign: false,
                value: invoice.totalAmountAfterTaxes,
              })}
            </SunshineCard.Text>

            <StatusBadge
              size="sm"
              status={invoice.status}
              type={InvoiceType.Invoice}
              width="max-content"
            />
          </VStack>
        </HStack>
      </SunshineCard.Content>
    </SunshineCard>
  );
};

export default Item;
